// extracted by mini-css-extract-plugin
export default {"root":"LandingHeader_root__UFxiy","mobileOnly":"LandingHeader_mobileOnly__0befJ","desktopOnly":"LandingHeader_desktopOnly__CVcMw"};